function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (prefers-reduced-motion: reduce) {\n        *,\n      ::before,\n      ::after {\n            animation-delay: -1ms !important;\n            animation-duration: 1ms !important;\n            animation-iteration-count: 1 !important;\n            background-attachment: initial !important;\n            scroll-behavior: auto !important;\n            transition-delay: 0s !important;\n            transition-duration: 0s !important;\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@emotion/react';
export var reduceMotion = css(_templateObject());